const browserLanguage = (
  (navigator.languages && navigator.languages[0]) ||
  navigator.language ||
  navigator.userLanguage
)
  .toLowerCase()
  .split(/[_-]+/)[0]
  .replace('se', 'sv');

export default browserLanguage;
